export default {"src":"/_next/static/image/public/images/ic_circle_with_minus.446c89fdcad22a14fe393201fbbca13c.svg","height":30,"width":30};